/**
 * @module components\ghTable\dataTable\dataRow\dataCell\actionsCell
 */
import Vue from "vue";
import Component from "vue-class-component";
import DataCellBase from "../dataCellBase";

@Component
export default class ActionsCell extends DataCellBase {
  private get actions() {
    if (this.header.actions) {
      if (this.props && this.props.item) {
        let opt = this.cellOptions;
        if (opt) {
          let hides = opt.hideActions;
          if (hides && hides.length > 0) {
            let actions: IRowAction[] = [];
            for (const iterator of this.header.actions) {
              if (
                hides.findIndex(v => v === iterator.value) < 0 &&
                !iterator.hide
              ) {
                actions.push(iterator);
              }
            }
            return actions;
          }
        }
      }

      return this.header.actions.filter(a => !a.hide);
    }
  }
}
